// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"100":"5498b086","209":"5498b086","376":"5498b086","534":"5498b086","836":"5498b086"}[chunkId] + ".chunk.css";
};